import * as React from 'react';
import { get } from 'lodash';
import VideoPlayer from './videojs-player';
import { checkValue } from '../../utils/functions';

export default class VideoDetails extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      loadedClass: ''
    };
  }

  public updateLoaded = isLoaded => {
    if (isLoaded) {
      this.setState({ loadedClass: 'image-loaded' });
    } else {
      this.setState({ loadedClass: '' });
    }
  };

  public render() {
    const getVideos = () => {
      const content = this.props;
      let isBackgroundImage = false;
      let isYoutube = false;

      const youtubeVideoUrl = checkValue(content.youtubeId) ? content.youtubeId.trim() : ""

      if (checkValue(content.videoFile) || checkValue(youtubeVideoUrl)) {
        let videoJsOptions = {};
        if (checkValue(content.videoFile)) {
          videoJsOptions = {
            autoplay: get(content, 'autoplay', true),
            controls: true,
            copyrightText: content.copyrightText,
            siteid: this.props.siteid,
            campaignUrl: this.props.campaignUrl,
            template: this.props.template,
            sources: [
              {
                src: content.videoFile[0].url,
                type: 'video/mp4'
              }
            ],
            muted: get(content , 'forceUnmuted' , false ) === true ? false : get(content, 'autoplay', true)
          };
        } else if (checkValue(youtubeVideoUrl)) {
          const reg = /^\d+$/ // number only
          const url = !youtubeVideoUrl.includes('vimeo') && !youtubeVideoUrl.includes('www.youtube') 
              ?  youtubeVideoUrl.match(reg) 
                ? `https://vimeo.com/${youtubeVideoUrl}` 
                : `https://www.youtube.com/embed/${youtubeVideoUrl}`  
              : youtubeVideoUrl

          try {
            const videoURL = new URL(url);
            const techOrder = videoURL.hostname.includes('youtube') ? 'youtube' : 'vimeo';
            let videoLink = youtubeVideoUrl;
            const mutedValue = get(content , 'forceUnmuted' , false ) === true ? "0" : "1"
            if (get(content, 'autoplay', true)) {
              if (techOrder === 'vimeo') {
                videoLink = videoLink.includes('?') ? `${youtubeVideoUrl}&muted=${mutedValue}` : `${youtubeVideoUrl}?muted=${mutedValue}`
              }
              else {
                videoLink = videoLink.includes('?') ? `${youtubeVideoUrl}&rel=0&amp;autoplay=1&mute=${mutedValue}` : `${youtubeVideoUrl}?rel=0&amp;autoplay=1&mute=${mutedValue}`
              }
            }
            isYoutube = true;
            videoJsOptions = {
              techOrder: [techOrder],
              autoplay: get(content, 'autoplay', true),
              controls: true,
              copyrightText: content.copyrightText,
              siteid: this.props.siteid,
              campaignUrl: this.props.campaignUrl,
              template: this.props.template,
              sources: [
                {
                  src: videoLink,
                  type: 'video/' + techOrder
                }
              ],
              muted: get(content , 'forceUnmuted' , false ) === true ? false : get(content, 'autoplay', true)
            };
          } catch (error) {
            console.log(error , "Invalid video url")
          }
        }

        if (
          content.staticImage !== undefined &&
          content.staticImage !== null &&
          content.staticImage !== '' &&
          content.staticImage.length > 0
        ) {
          const filteredData = content.staticImage.filter(heroItem => heroItem.name.includes(this.props.device));
          if (filteredData[0] && filteredData[0] !== undefined && filteredData[0] !== null && filteredData[0] !== '') {
            const imgURL: string = filteredData[0].url;
            videoJsOptions['poster'] = imgURL;
            if (isYoutube) {
              isBackgroundImage = true;
            }
          }
        }

        const videoProps = {
          videoOptions: videoJsOptions,
          isBackground: isBackgroundImage
        };

        return (
          <div className={`video-wrapper ${this.state.loadedClass}`}>
            <VideoPlayer {...videoProps} />
          </div>
        );
      }
    };

    return <>{getVideos()}</>;
  }
}
